import { render, staticRenderFns } from "./pledgedetail.vue?vue&type=template&id=30634abe&"
import script from "./pledgedetail.vue?vue&type=script&lang=js&"
export * from "./pledgedetail.vue?vue&type=script&lang=js&"
import style0 from "./pledgedetail.vue?vue&type=style&index=0&id=30634abe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports